import { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Button } from '../../../iba-components/Button'
import { Table } from '../../../iba-components/Table'
import { showPopBanner } from '../../../iba-components/PopBanner'
import { Loading } from '../../components/Loading'
import { EditThemeModal } from '../../components/EditThemeModal'
import ConfirmModal from '../../components/ConfirmModal'
import { fetchClientThemes, deleteClientThemeMap } from '../../api/theme'
import { getColumnList } from './tableColumns'

export const CLIENT_THEME_TYPE = 'client'
export const FAILED_STATUS = '2'

export const ClientTheme = () => {
    const { t } = useTranslation()
    const [loading, setLoading] = useState(false)
    const [listData, setListData] = useState([])
    const [id, setId] = useState()
    const [themeDetailData, setThemeDetailData] = useState()
    const [showModal, setShowModal] = useState(false)
    const [showDeleteConfirm, setShowDeleteConfirm] = useState(false)
    const [idToDelete, setIdToDelete] = useState()

    const deleteConfirm = (e, props) => {
        e.stopPropagation()
        setIdToDelete({
            id: props.id,
            name: props.name
        })
        setShowDeleteConfirm(true)
    }

    const generateErrorMsg = (list) => {
        let clients = ``
        if (list && !!list.length) {
            list.forEach((it, index) => {
                if (index === list.length - 1) {
                    clients = `${clients}「${it.name}」 `
                } else {
                    clients = `${clients}「${it.name}」、`
                }
            })
        }
        return (
            <div>
                <div>{t(`theme.warningMsg.optError`)}</div>
                {clients && (
                    <div>
                        {t(`theme.warningMsg.clientThemeDeleteError`, {
                            clientThemeName: idToDelete.name,
                            clients
                        })}
                    </div>
                )}
            </div>
        )
    }

    const handleDeleteTheme = async () => {
        if (idToDelete) {
            setShowDeleteConfirm(false)
            setLoading(true)
            const res = await deleteClientThemeMap({ id: idToDelete.id })
            setLoading(false)
            if (res) {
                if (res.hasError && res.status === FAILED_STATUS) {
                    showPopBanner({
                        message: generateErrorMsg(res.companys),
                        status: 'error',
                        duration: 10000
                    })
                } else {
                    fetchData()
                    setIdToDelete()
                    showPopBanner({
                        message: t(`theme.warningMsg.optSuccess`),
                        status: 'success',
                        duration: 2000
                    })
                }
            }
        }
    }

    const handleNew = () => {
        setId(null)
        setThemeDetailData(null)
        setShowModal(true)
    }

    const handleTrClick = (original) => {
        setId(original.id)
        setThemeDetailData(original)
        setShowModal(true)
    }

    const handleModalCancel = () => {
        setShowModal(false)
    }

    const handleSaveCallback = () => {
        fetchData()
    }

    const fetchData = async () => {
        setLoading(true)
        const res = await fetchClientThemes()
        setLoading(false)
        if (res) {
            setListData(res.data)
        }
    }

    useEffect(() => {
        fetchData()
    }, [])

    return (
        <>
            <div className="themeContainer">
                <div className="header">
                    <div className="flex-middle flex-between">
                        <div className="title">{t('theme.clientTheme.title')}</div>
                        <Button width="96px" label={t('systemInfoManagement.new')} onClick={handleNew} />
                    </div>
                </div>
                <Loading visible={loading}>
                    <Table
                        data={listData}
                        columns={getColumnList(t, deleteConfirm)}
                        handleClickRow={handleTrClick}
                        sort={[
                            {
                                id: 'created_date',
                                desc: true
                            }
                        ]}
                        isBottomPagination={false}
                        isDownload={false}
                    />
                </Loading>
            </div>
            {showModal && (
                <EditThemeModal
                    showModal={showModal}
                    title={id ? t('theme.modal.clientTheme.editTitle') : t('theme.modal.clientTheme.addTitle')}
                    id={id}
                    themeName={themeDetailData?.name}
                    selectedItems={themeDetailData?.base_theme_map_id}
                    handleCancel={handleModalCancel}
                    handleSaveCallback={handleSaveCallback}
                    type={CLIENT_THEME_TYPE}
                    keyField="id"
                />
            )}
            {showDeleteConfirm && (
                <ConfirmModal
                    visible={showDeleteConfirm}
                    content={t('theme.warningMsg.deleteConfirm', {
                        name: idToDelete.name
                    })}
                    onCancel={() => setShowDeleteConfirm(false)}
                    onSubmit={handleDeleteTheme}
                />
            )}
        </>
    )
}
